/**
 * 会员管理模块路由
 * 路径前缀: /desktopCenter/memberManage/
 */
import type { RouteRecordRaw } from "vue-router";

export const memberManageRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/memberManage/memberList",
		name: "MemberList",
		meta: {
			title: "会员列表",
			keepAlive: false,
		},
		redirect: "/desktopCenter/memberManage/memberList/list",
		children: [
			{
				path: "/desktopCenter/memberManage/memberList/list",
				name: "MemberListDetail",
				meta: {
					title: "会员列表",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/member/person",
				},
				component: () =>
					import("@main/views/Apps/MemberManage/MemberList/MemberList/MemberList.vue"),
			},
			{
				path: "/desktopCenter/memberManage/memberList/joinApplication",
				name: "JoinApplication",
				meta: {
					title: "入会申请",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/member/apply/person",
				},
				component: () =>
					import("@main/views/Apps/MemberManage/MemberList/JoinApplication/JoinApplication.vue"),
			},
			{
				path: "/desktopCenter/memberManage/memberList/paymentRecord",
				name: "PaymentRecord",
				meta: {
					title: "缴费记录",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/member/pay/index",
				},
				component: () =>
					import("@main/views/Apps/MemberManage/MemberList/PaymentRecord/PaymentRecord.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/memberManage/joinSettings",
		name: "JoinSettings",
		meta: {
			title: "入会设置",
			keepAlive: false,
		},
		redirect: "/desktopCenter/memberManage/joinSettings/joinSettings",
		children: [
			{
				path: "/desktopCenter/memberManage/joinSettings/joinSettings",
				name: "JoinSettingsDetail",
				meta: {
					title: "入会设置",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/member/set/index",
				},
				component: () => import("@main/views/Apps/MemberManage/JoinSettings/JoinSettings.vue"),
			},
			{
				path: "/desktopCenter/memberManage/joinSettings/memberType",
				name: "MemberType",
				meta: {
					title: "会员类型",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/member/join_config",
				},
				component: () =>
					import("@main/views/Apps/MemberManage/JoinSettings/MemberType/MemberType.vue"),
			},
			{
				path: "/desktopCenter/memberManage/joinSettings/memberLevel",
				name: "MemberLevel",
				meta: {
					title: "会员级别",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/member/level",
				},
				component: () =>
					import("@main/views/Apps/MemberManage/JoinSettings/MemberLevel/MemberLevel.vue"),
			},
			{
				path: "/desktopCenter/memberManage/joinSettings/electronicBadge",
				name: "ElectronicBadge",
				meta: {
					title: "电子会牌",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/willbrand/index",
				},
				component: () =>
					import("@main/views/Apps/MemberManage/JoinSettings/ElectronicBadge/ElectronicBadge.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/memberManage/userManage",
		name: "MemberUserManage",
		meta: {
			title: "用户管理",
			keepAlive: false,
		},
		redirect: "/desktopCenter/memberManage/userManage/userList",
		children: [
			{
				path: "/desktopCenter/memberManage/userManage/userList",
				name: "MemberUserList",
				meta: {
					title: "用户列表",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/user/user",
				},
				component: () => import("@main/views/Apps/MemberManage/UserManage/UserList/UserList.vue"),
			},
			{
				path: "/desktopCenter/memberManage/userManage/userPromotion",
				name: "UserPromotion",
				meta: {
					title: "用户推广",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/member/promotion",
				},
				component: () =>
					import("@main/views/Apps/MemberManage/UserManage/UserPromotion/UserPromotion.vue"),
			},
		],
	},
];
